
<div class="container-fluid" id="capture">
  <div class="row ">

    <div class="col-12 col-sm-12">
      <div class="mb-3">
      <select class="custom-select select2" id="sucursal" [(ngModel)]="sucursal"
        (ngModelChange)="getCentroCostos(sucursal)">
        <!-- <option  value="">Seleccione...</option> -->
        <option value="undefined" selected>Select Sucursal </option>
        <option *ngFor="let plant of plants" [value]="plant.id_planta">{{plant.nom_planta}}</option>
      </select>

      <select class="custom-select" id="orden_ceco" [(ngModel)]="orden_ceco" (ngModelChange)="getLineas(orden_ceco)">
        <option value="undefined" selected>Select Centro de Costo </option>
        <option *ngFor="let ceco of centroCostos" [value]="ceco.orden_ceco">{{ceco.nombre_ceco}}</option>
      </select>

      <select class="custom-select" id="linea" [(ngModel)]="linea" (ngModelChange)="getShowParams()">
        <!-- "" (ngModelChange)="refresh(1)" -->
        <option value="undefined" selected>Select Linea </option>
        <option *ngFor="let lin of lineas" [value]="lin.id">{{lin.nombre}}</option>
      </select>
    </div>
    </div>


    <!-- <div  *ngIf="id_filtro_linea1  && tipo1==2"> -->
      <!-- <div class="mb-3"> -->
        <button (click)="mostrarBootstrapModal()"  class="btn btn-primary buttonG"  *ngIf="id_filtro_linea1  && tipo1==2">
          Capturar Ubicación</button>




        <!-- <select class="form-control form-select" [(ngModel)]="showSalida"  (ngModelChange)="getShowFiltro()"  aria-label="Default select example">
          <option value="undefined" selected >--Seleccione--</option>
          <option [value]="2">Ingreso o Salida</option>
          <option [value]="1">Marca puntos de entrega</option>
        </select> -->
      <!-- </div> -->




      <!-- <input type="text" id="filtro_linea" class="col-12 text-end control-label col-form-label"  *ngIf="showSalida>=1"
        [placeholder]="parametro1" [(ngModel)]="filtro_linea"> -->




      <!-- <div class="mb-3"  *ngIf="showSalida>=1">
        <select class="form-control form-select" [(ngModel)]="entrega">
          <option value="undefined" selected>--Estado del paquete--</option>
          <option [value]="1">Entregado</option>
          <option [value]="0">No entregado</option>
        </select>
        <textarea class="form-control" rows="3" placeholder="Observacion de la entrega..."
          [(ngModel)]="observaciones"></textarea>
      </div> -->
    <!-- </div> -->

    <!-- <div class="col-12 col-sm-12">
      <div class="form-check" *ngIf="id_filtro_linea1  && tipo1==2">
        <input type="checkbox" id="md_checkbox_21" class="material-inputs filled-in chk-col-red"
          [(ngModel)]="showSalida" data-md-icheck (change)="toggleVisibility($event)">
        <label class="form-check-label" *ngIf="!showSalida" for="md_checkbox_21">Timbrar Salida</label>
        <label class="form-check-label" *ngIf="showSalida" for="md_checkbox_21">Deshabilitar timbre de Salida</label>
      </div>
    </div> -->
      <!-- <div class="col-12 col-sm-12" *ngIf="!tipo1  && linea"> -->
        <button class="btn btn-danger buttonG" (click)="addCapture(1)">Capturar</button>
      <!-- </div> -->
  </div>

  <div class="col-12 input-group resposive">
    <span class="input-group-btn">
      <input type="text" id="cedula" class="form-control" [placeholder]="'Ingrese el Código'" [(ngModel)]="cedula">
    </span>
    <span class="input-group-btn">
      <button class="btn btn-primary rounded-0" (click)="addCode()">CODE</button>
    </span>

  </div>


</div>


<ng-template #modalSucces let-modal>
  <div class="modal-header" [ngStyle]="{'background': result.error == 0 ? 'lime' : 'firebrick'}">
    <h3 class="modal-title text-white">Registro </h3>
    <button type="button" class="close dif" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div *ngIf="result.error == 1">
      <div class="text-center">
        <a><i class="fa fa-exclamation-triangle error"></i>
          <h3 class="style">{{result.mensaje}}</h3>
          <h3 class="style">{{result.nombres}}</h3>
        </a>
      </div>
    </div>
    <div *ngIf="result.error == 0">
      <div class="text-center">
        <a><i class="fa fa-check-square-o check"></i>
          <h3 class="style">{{result.mensaje}}</h3>
          <h3 class="style">{{result.nombres}}</h3>
        </a>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div *ngIf="result.error == 1">
      <a type="button" class="btn btn-danger text-white" data-dismiss="modal" (click)="modal.dismiss()">Close</a>
    </div>
    <div *ngIf="result.error == 0">
      <div>
        <a type="button" class="btn btn-success text-white" data-dismiss="modal" (click)="modal.dismiss()">Close</a>
      </div>
    </div>
  </div>
</ng-template>


<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
  <div class="btn-toolbar mb-2 mb-md-0">
    <!-- *ngIf="canAccess(['edit_users'])"-->
    <!-- <a routerLink="/plants/create" class="btn btn-sm btn-outline-secondary">Agregar</a> -->
    <!-- <button (click)="mostrarBootstrapModal(null,'save')" class="btn btn-sm btn-outline-secondary"  >Agregar</button> -->
  </div>
</div>



<!-- <h1>Barcode Scanner - detected barcode: <small style="color: blue">{{value}}</small></h1>
<p style="color:red" *ngIf="isError">Barcode scan is not available.</p>
<ngx-barcode-scanner [(value)]="value" [codes]="['code_128', 'ean', 'upc', 'upc_e', 'ean_8']" [errorThreshold]="0.1" (exception)="onError($event)"></ngx-barcode-scanner> -->





<div class="table-responsive">
  <table class="table ">
    <thead>
      <tr>
        <th>fecha</th>
        <th>Nombres</th>
        <th>Inicio</th>
        <th>Fin</th>
        <th>c_diur</th>
        <th>c_noc</th>
        <th>c_fes_d</th>
        <th>c_fes_n</th>

      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let per of dataRegisPers">
        <td>{{per.fecha}}</td>
        <td>{{per.nombres}}</td>
        <td>{{per.fecha_inicio}}</td>
        <td>{{per.fecha_fin}}</td>
        <td>{{per.c_diur}}</td>
        <th>{{per.c_noc}}</th>
        <th>{{per.c_fes_d }}</th>
        <th>{{per.c_fes_n }}</th>
      </tr>
    </tbody>
  </table>
</div>



<!-- <scanner ></scanner> -->
<!-- <app-scanner></app-scanner> -->

<!-- <app-paginator [lastPage]="lastPage" (pageChanged)="refresh($event)"></app-paginator> -->
